import { createSelector } from "reselect";

import { Lead } from "@mapmycustomers/shared/types/entity";

import { getFilteredLeadFinderRecords } from "@app/component/leadFinder/store/selectors";
import { RootState } from "@app/store/rootReducer";

import { RouteLeadFinderState } from "./index";

export const getRouteLeadFinder = (state: RootState): RouteLeadFinderState =>
  state.scene.route.routeDetails.leadFinder;

export const getSelectedLeadPlaceIds = (state: RootState): Array<Lead["place_id"]> =>
  getRouteLeadFinder(state).selectedLeadPlaceIds;

export const getSelectedLeadPlaceIdsSet = createSelector(
  getSelectedLeadPlaceIds,
  (ids) => new Set(ids)
);

export const getHighlightedLeadPlaceIds = (state: RootState): Set<Lead["place_id"]> =>
  getRouteLeadFinder(state).highlightedLeadPlaceIds;

export const isLeadFinderResultsVisible = (state: RootState): boolean =>
  getRouteLeadFinder(state).resultsVisible;

export const getSelectedLeads = createSelector(
  getFilteredLeadFinderRecords,
  getSelectedLeadPlaceIds,
  (records, selectedPlaceIds): Lead[] => {
    const selectedPlaceIdSet = new Set(selectedPlaceIds);
    return records.filter((lead) => selectedPlaceIdSet.has(lead.place_id));
  }
);
